<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="flex-center pd-25 color-fff main-top" :style="{background: selectType == 0?'#FF8500':'#FF4242'}">
            <div class="top-img"><img :src="iconImg" alt=""></div>
            <div class="flex1 ml-25 mr-25">
                <div class="fs-32 font-bold">{{entity.shopName}}</div>
                <div class="flex fs-28 mt-10">
                    <div>数量：{{entity.totalRfidCount}}</div>
                    <div style="margin-left: .5rem;">种类：{{entity.totalTypeCount}}</div>
                </div>
            </div>
            <div class="fs-32 font-bold">待处理</div>
        </div>

        <div class="product-list">
            <div class="product-item fs-26" v-for="(item,$index) in entity.itemList" :key="$index">
                <div class="item-img"><img :src="item.mainPicView" alt=""></div>
                <div class="item-info">
                    <div class="color-000 text-el">{{item.productName}}</div>
                    <div class="mt-10 color-999">数量: <span class="color-warning">{{item.rfidCount}}</span></div>
                    <div class="mt-5 color-999">{{selectType == 0?'剩余':'过期'}}天数: <span class="color-warning">{{item.residueDay}}天</span></div>
                </div>
            </div>
        </div>

        <div class="bot-address">
            <div class="alifont icon-dizhi"></div>
            <div class="fs-28">{{entity.address}}</div>
        </div>
    </div>
</template>

<script>
    import {qryArmShopItemListByShop ,qryExpireShopItemListByShop} from '@/api/product'
    import util from "@/utils/index"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import store from "../../store";
    export default {
        name: "overDateWarningDetail",
        components:{backTitleBar},
        data(){
            return{
                iconImg1: require("../../assets/images/warning/w1.png"),
                iconImg2: require("../../assets/images/warning/w2.png"),
                entity:{}
            }
        },
        computed:{
            'iconImg':function () {
                if(this.selectType == 0){
                    return this.iconImg1
                }else{
                    return this.iconImg2
                }
            }
        },
        created() {
            this.$store.state.showFooter = false;
            this.shopId = this.$route.query.shopId;  //柜子Id
            this.selectType = this.$route.query.selectType;  //查询类型(0过期预警 1过期)
            this.getDetail();
        },
        methods:{
            getDetail(){
                let param = {
                    shopId : this.shopId,
                }
                if(this.selectType == 0){
                    document.title = store.webTitle = '过期预警'
                    qryArmShopItemListByShop(param).then(res=>{
                        this.entity = res.data;
                    })
                }else if(this.selectType == 1){
                    document.title = store.webTitle = '已过期'
                    qryExpireShopItemListByShop(param).then(res=>{
                        if(res.data.itemList.length != 0){
                            res.data.itemList.forEach(item=>{
                                item.showDate = util.formatDate(new Date(new Date(item.expireTime.replace(/\-/g, "/")).getTime()),'MM-dd');
                            })
                        }
                        this.entity = res.data;
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .top-img{
        width: .96rem;
        height: .96rem;
    }
    .main-top{
        background: $org;
    }
    .product-list{
        padding: .2rem .24rem;
        display: flex;
        flex-wrap: wrap;
        .product-item{
            width: 2.26rem;
            margin-right: .12rem;
            margin-bottom: .12rem;
            background: #fff;
            border-radius: .06rem;
            &:nth-child(3n){
                margin-right: 0;
            }
            .item-img{
                width: 100%;
                height: 2.26rem;
            }
            .item-info{
                padding: .16rem .14rem .2rem;
            }
        }
    }
    .bot-address{
        background: rgba(0,0,0,.7);
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        padding: .2rem .24rem;
        color: #fff;
        .alifont{
            font-size: .48rem;
            margin-right: .2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// overDateDetail.vue?269ed9de